import React, { useState } from "react";
import { Box, CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import DashboardHome from "./components/DashboardHome";
import Links from "./pages/Links";
import Users from "./pages/Users";
import Stats from "./pages/Stats";
import Logs from "./pages/Logs";
import { Routes, Route, Navigate } from "react-router-dom";
import Notifications from './pages/Notifications';

export default function AppAdmin() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("admin_dark_mode");
    return saved ? JSON.parse(saved) : false;
  });

  const handleSetDarkMode = (val) => {
    setDarkMode(val);
    localStorage.setItem("admin_dark_mode", JSON.stringify(val));
  };

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: { main: "#6366f1" },
      secondary: { main: "#06b6d4" }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
        <Sidebar />
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <Header darkMode={darkMode} setDarkMode={handleSetDarkMode} />
          <Box sx={{ flex: 1, p: { xs: 2, sm: 5 }, bgcolor: "background.default" }}>
            <Routes>
              <Route index element={<DashboardHome />} />
              <Route path="links" element={<Links />} />
              <Route path="users" element={<Users />} />
              <Route path="stats" element={<Stats />} />
              <Route path="logs" element={<Logs />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
